import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"
import { positionDropdownMenu } from "./dropdown_positioning"

// The issue list's status and assignee menus sit inside .table-responsive, which clips anything
// past its own edges: with only a row or two, an open menu was cut off and the table grew its own
// scrollbar to reach it. The toggles opt out of Popper (data-bs-display="static") and each menu
// is placed against the viewport instead (see dropdown_positioning.js), opening upward when there
// isn't room below. A fixed menu doesn't move with the page, so scrolling closes it.
export default class extends Controller {
  connect() {
    this.place = this.place.bind(this)
    this.closeOpen = this.closeOpen.bind(this)
    this.element.addEventListener("shown.bs.dropdown", this.place)
    window.addEventListener("scroll", this.closeOpen, { passive: true })
    this.element.addEventListener("scroll", this.closeOpen, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.dropdown", this.place)
    window.removeEventListener("scroll", this.closeOpen)
    this.element.removeEventListener("scroll", this.closeOpen)
  }

  place(event) {
    const toggle = event.target
    const menu = toggle.parentElement.querySelector(".dropdown-menu")
    if (!menu) return

    menu.style.maxHeight = ""
    menu.style.overflowY = ""
    positionDropdownMenu(toggle, menu)
    const rect = toggle.getBoundingClientRect()
    const height = menu.getBoundingClientRect().height
    if (rect.bottom + height <= window.innerHeight) return

    // Upward only when it clears the sticky header; otherwise down, scrolling within itself.
    const header = document.querySelector(".sticky-top")?.getBoundingClientRect().bottom || 0
    if (rect.top - height >= header) {
      menu.style.top = `${rect.top - height}px`
    } else {
      menu.style.maxHeight = `${Math.max(window.innerHeight - rect.bottom - 8, 120)}px`
      menu.style.overflowY = "auto"
    }
  }

  closeOpen() {
    this.element.querySelectorAll("[data-bs-toggle='dropdown'][aria-expanded='true']").forEach((toggle) => {
      Dropdown.getInstance(toggle)?.hide()
    })
  }
}
